import React, { useEffect, useState } from 'react';
import BarChart from '../chart/BarChart';
import Loader from "../loader/Loader";
import config from "../../config/config";
import axios from "axios";
import DataTable from 'react-data-table-component';
import { getAuthToken } from "../../utils/token";
import ManpowerOvertime from './ManpowerOvertime';
export default function ResourceReports() {
  const [manpower, setManpower] = useState([])
  const [loading, setLoading] = useState(false);
  const [barChartData, setBarChartData] = useState([])
  const [manpowerReport, setManpowerReport] = useState([])
  const [maintenancecalibration, setMaintenancecalibration] = useState("")
  const [reportData, setReportData] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [operatorData, setOperatorData] = useState([]);
  const [startDateOperator, setStartDateOperator] = useState("");
  const [endDateOperator, setEndDateOperator] = useState("");
  const customStyles = {
    headCells: {
      style: {
        fontWeight: 'bold',
        fontSize: '14px',
        backgroundColor: '#f8f9fa',
      },
    },
  };
  const fetchMachineWiseReport = async () => {
    try {
      setLoading(true);
      const token = getAuthToken();
      let payload = {};
      if (startDate && endDate) {
        payload = {
          start_date: startDate,
          end_date: endDate,
        };
      }
      const response = await axios.post(
        `${config.API}/senmanager/machinepewisereport`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.success) {
        setReportData(response?.data?.data);
      } else {
        setReportData([]);
      }
    } catch (err) {
      console.error("Error fetching machine wise report", err);
    } finally {
      setLoading(false);
    }
  };
  const fetchOperaotrReport = async () => {
    try {
      setLoading(true);
      const token = getAuthToken();
      let payload = {};
      if (startDateOperator && endDateOperator) {
        payload = {
          start_date: startDateOperator,
          end_date: endDateOperator,
        };
      }
      const response = await axios.post(
        `${config.API}/senmanager/operatorwisereport`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.success) {
        setOperatorData(response?.data?.data);
      } else {
        setOperatorData([]);
      }
    } catch (err) {
      console.error("Error fetching machine wise report", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchMachineWiseReport();
    fetchOperaotrReport()
  }, []);
  const MachineColumns = [
    {
      name: "Machine ID",
      selector: row => row.machine_id,
      sortable: true,
    },
    {
      name: "Machine Name",
      selector: row => row.machine_name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Product",
      selector: row => row.product_name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Produced",
      selector: row => row.total_produced,
      sortable: true,
      center: true,
    },
    {
      name: "Rejected",
      selector: row => row.total_rejected,
      center: true,
    },
    {
      name: "Recycled",
      selector: row => row.total_recycled,
      center: true,
    },
    {
      name: "Efficiency %",
      selector: row => `${row.efficiency_percentage}%`,
      center: true,
    },
  ];
  const OperatorColumns = [
    {
      name: "Operator Name",
      selector: row => row.operator_name,
      sortable: true,
      wrap: true,
    },
    {
      name: "machine",
      selector: row => row.machine_id,
      sortable: true,
      wrap: true,
    },
    {
      name: "Product",
      selector: row => row.product_name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Produced",
      selector: row => row.total_produced,
      sortable: true,
      center: true,
    },
    {
      name: "Rejected",
      selector: row => row.total_rejected,
      center: true,
    },
    {
      name: "Recycled",
      selector: row => row.total_recycled,
      center: true,
    },
    {
      name: "Efficiency %",
      selector: row => `${row.efficiency_percentage}%`,
      center: true,
    },
  ];
  const fetchBarChartReport = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/senmanager/materialConsumption`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const result = response?.data;
      if (result?.success) {
        setBarChartData(result);
        console.log(result, "result222")
      } else {
        console.warn("API call failed:", result?.message || "Something went wrong");
      }
    } catch (err) {
      console.error("Error fetching fetchBarChartReport:", err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchManpower = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/senmanager/manpowerDeployment`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const result = response?.data;
      if (result?.success) {
        setManpower(result?.data);
      } else {
        console.warn("API call failed:", result?.message || "Something went wrong");
      }
    } catch (err) {
      console.error("Error fetching manpowerDeployment:", err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchManpowerReport = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/senmanager/manpowerreport`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const result = response?.data;
      if (result?.success) {
        setManpowerReport(result);
        console.log("fetchManpowerReport Data:", result?.data);
      } else {
        console.warn("API call failed:", result?.message || "Something went wrong");
      }
    } catch (err) {
      console.error("Error fetching fetchManpowerReport:", err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchMaintenancecalibrationoverview = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/senmanager/maintenancecalibrationoverview`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const result = response?.data;
      if (response.status === 200 && result?.success === true) {
        setMaintenancecalibration(result?.data);
        console.log("setMaintenancecalibration", result)
      } else {
        console.warn("API call failed:", result?.message || "Something went wrong");
      }
    } catch (err) {
      console.error("Error fetching setNcReport", err.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchManpower()
    fetchBarChartReport()
    fetchManpowerReport()
    fetchMaintenancecalibrationoverview()
  }, [])
  const BarChartData = {
    labels: barChartData?.data?.map((item) => item?.material_master?.material_name),
    datasets: [
      {
        label: "Planned",
        data: barChartData?.data?.map((item) => item?.total_consumed),
        backgroundColor: "#0a28a3",
      },
    ],
  };


  const columns = [
    {
      name: 'Equipment',
      selector: row => `${row.machine_name} ${row.machine_code ?? 'NA'}`,
      sortable: true,
      wrap: true,
    },
    {
      name: 'Last Maintenance',
      selector: row => row.last_maintenance_date ? row.last_maintenance_date : 'NA',
      sortable: true
    },
    {
      name: 'Next Maintenance',
      selector: row => row.next_maintenance_due ? row.next_maintenance_due : 'NA',
      sortable: true,
      right: true
    },
    {
      name: 'Status',
      selector: row => row.status,
      sortable: true,
      cell: (row) => {
        const status = row?.status || "N/A";
        return (
          <span
            className={`px-2 py-1 rounded fw-bold ${status?.toLowerCase() === "running"
                ? "bg-success-subtle text-success"
                : "bg-danger-subtle text-danger"
              }`}
          >
            {status}
          </span>
        );
      }
    },
    { name: 'Calibration', selector: row => row.calibration_status, sortable: true },
  ];
  return (
    <div className='container-fluid'>
      {/* Chart */}
      <div className="row g-3 mt-1">
        <div className="col-12">
          <div className="p-3 border rounded-3 bg-white shadow-sm">

            <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                <strong
                  className="fs-5"
                  style={{ color: "#17365d" }}
                >
                  Manpower Deployment
                </strong>
                <div className="text-muted small">
                  Current operator & machine allocation
                </div>
              </div>

              {manpower?.length > 0 && (
                <span className="badge bg-primary rounded-pill px-3 py-2">
                  {manpower.length} Deployed
                </span>
              )}
            </div>

            {loading ? (
              <Loader />
            ) : manpower?.length > 0 ? (
              <div
                className="d-flex gap-3 overflow-auto pb-2"
                style={{
                  scrollbarWidth: "thin",
                  whiteSpace: "nowrap",
                }}
              >
                {manpower.map((item, index) => (
                  <div
                    key={index}
                    className="border rounded-3 shadow-sm bg-light p-3 flex-shrink-0"
                    style={{
                      width: "260px",
                      borderLeft: "4px solid #198754",
                    }}
                  >
                    <div className="d-flex align-items-center gap-2 mb-3">
                      <div
                        className="rounded-circle d-flex align-items-center justify-content-center fw-bold"
                        style={{
                          width: "38px",
                          height: "38px",
                          background: "#e8f5ee",
                          color: "#198754",
                        }}
                      >
                        {(item?.user?.name || "U")
                          .charAt(0)
                          .toUpperCase()}
                      </div>

                      <div
                        className="fw-bold text-dark text-truncate"
                        style={{
                          maxWidth: "185px",
                        }}
                      >
                        {item?.user?.name || "Unknown"}
                      </div>
                    </div>

                    <div className="small text-muted mb-1">
                      OPERATOR
                    </div>

                    <div className="fw-semibold text-dark mb-3 text-truncate">
                      {item?.user?.name || "NA"}
                    </div>

                    <div className="d-flex align-items-center justify-content-between gap-2">
                      <div className="text-truncate">
                        <div className="small text-muted">
                          MACHINE
                        </div>
                        <div
                          className="fw-semibold text-dark text-truncate"
                          title={item?.machine?.line || "NA"}
                        >
                          {item?.machine?.line || "NA"}
                        </div>
                      </div>

                      <span
                        className="badge rounded-pill"
                        style={{
                          background: "#e8f1ff",
                          color: "#2563eb",
                        }}
                      >
                        {item?.shift || "NA"}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center text-muted py-4">
                <div className="fw-semibold">
                  No manpower deployed
                </div>
                <small>
                  No operators are currently assigned.
                </small>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="card mt-4">
        <ManpowerOvertime />
      </div>

      <div className="row mt-2 g-3">
        <div className="col-md-6">
          <div className=" card border rounded p-4 h-100">
            <h5 className="fw-bold mb-3">Machine wise Report</h5>
            <div className="row mb-3">
              <div className="col-md-4">
                <input
                  type="date"
                  className="form-control"
                  value={startDate}
                  onChange={e => setStartDate(e.target.value)}
                />
              </div>
              <div className="col-md-4">
                <input
                  type="date"
                  className="form-control"
                  value={endDate}
                  onChange={e => setEndDate(e.target.value)}
                />
              </div>
              <div className="col-md-4">
                <button
                  className="btn btn-primary w-100"
                  onClick={fetchMachineWiseReport}
                >
                  Apply Filter
                </button>
              </div>
            </div>
            {
              loading ? (
                <Loader />
              ) : (
                <>
                  <DataTable
                    columns={MachineColumns}
                    data={reportData}
                    progressPending={loading}
                    pagination
                    highlightOnHover
                    paginationPerPage={10}
                    paginationRowsPerPageOptions={[10, 20, 30, 50]}
                    customStyles={customStyles}
                    noDataComponent="No machine data found"
                  />
                </>
              )
            }
          </div>
        </div>
        <div className="col-md-6">
          <div className=" card border rounded p-4 h-100">
            <h5 className="fw-bold mb-3">Operator wise Report</h5>
            <div className="row mb-3">
              <div className="col-md-4">
                <input
                  type="date"
                  className="form-control"
                  value={startDateOperator}
                  onChange={e => setStartDateOperator(e.target.value)}
                />
              </div>
              <div className="col-md-4">
                <input
                  type="date"
                  className="form-control"
                  value={endDateOperator}
                  onChange={e => setEndDateOperator(e.target.value)}
                />
              </div>
              <div className="col-md-4">
                <button
                  className="btn btn-primary w-100"
                  onClick={fetchOperaotrReport}
                >
                  Apply Filter
                </button>
              </div>
            </div>
            {
              loading ? (
                <Loader />
              ) : (
                <>
                  <DataTable
                    columns={OperatorColumns}
                    data={operatorData}
                    progressPending={loading}
                    pagination
                    highlightOnHover
                    paginationPerPage={10}
                    paginationRowsPerPageOptions={[10, 20, 30, 50]}
                    customStyles={customStyles}
                    noDataComponent="No machine data found"
                  />
                </>
              )
            }
          </div>
        </div>
      </div>
      <div className="mt-4 card">
        <div className="card-body font_family">
          <strong className="card-title fw-bold mb-4 fs-4 mt-2">Manpower Reports</strong>
          <div className="row mt-3">
            <div className="col-md-6">
              <h6 className="fw-semibold mb-3">People Deployed vs Output</h6>
              <div className="row mb-2">
                <div className="col-6">Total Operators</div>
                <div className="col-6 text-end fw-semibold">{manpowerReport?.data?.total_operators}</div>
              </div>
              <div className="row mb-2">
                <div className="col-6">Total Output</div>
                <div className="col-6 text-end fw-semibold">{manpowerReport?.data?.production_log || 0} units</div>
              </div>
              <div className="row mb-2">
                <div className="col-6">Units per Person</div>
                <div className="col-6 text-end fw-semibold">{manpowerReport?.data?.unit_per_operator} units</div>
              </div>
              <div className="row mb-2">
                <div className="col-6">YoY Improvement</div>
                <div className="col-6 text-end fw-semibold text-success">+{manpowerReport?.data?.yoy_growth}</div>
              </div>
            </div>
            <div className="col-md-6">
              <h6 className="fw-semibold mb-3">Productivity Metrics</h6>
              <div className="row mb-2">
                <div className="col-8">OEE (Overall Equipment Effectiveness)</div>
                <div className="col-4 text-end fw-semibold">{manpowerReport?.data?.oee ? Number(manpowerReport?.data?.oee).toFixed(2) : 0}% </div>
              </div>
              <div className="row mb-2">
                <div className="col-8">Labor Productivity</div>
                <div className="col-4 text-end fw-semibold">{manpowerReport?.data?.labor_productivity ? Number(manpowerReport?.data?.labor_productivity).toFixed(2) : 0}%</div>
              </div>
              <div className="row mb-2">
                <div className="col-8">Material Efficiency</div>
                <div className="col-4 text-end fw-semibold">{manpowerReport?.data?.material_efficiency ? Number(manpowerReport?.data?.material_efficiency).toFixed(2) : 0}%</div>
              </div>
              <div className="row mb-2">
                <div className="col-8">Overall Productivity</div>
                <div className="col-4 text-end fw-semibold"> {manpowerReport?.data?.overall_productivity
                  ? Number(manpowerReport.data.overall_productivity).toFixed(2)
                  : 0}% </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
}
